import { combineReducers } from 'redux';
import commonStoreReducer from '../../CommonDataStore/reducer';
import metaDataReducer from '../../MetaDataStore/reducer';
import {
    COMMON_DATA_LIST_EVENTS_ERROR,
    COMMON_DATA_LIST_EVENTS_LOADING_SUCCESS,
    COMMON_DATA_LIST_EVENTS_START_LISTENING_FOR_WS_UPDATES,
    COMMON_DATA_LIST_EVENTS_STOP_LISTENING_FOR_WS_UPDATES,
} from './../actions/commonDataListEventsActionsTypes';
import mainSocket from '../../../../../shared/services/mainSocketClass';
import { WS_HANDLER_COMPONENT_NAME } from '../constants';

/**
 * Main Common Data List Events reducer
 * @param {*} state the current state
 * @param {*} action the action
 * @returns {*} new state
 */
function commonDataListEventsReducer(state = {events: {}}, action) {
    switch (action.type) {
        case COMMON_DATA_LIST_EVENTS_LOADING_SUCCESS: {
            return { ...state, events: action.events };
        }
        case COMMON_DATA_LIST_EVENTS_START_LISTENING_FOR_WS_UPDATES: {
            const { selectionPointers } = action;
            if (!selectionPointers.length) {
                return state;
            }

            /**
             * @todo AM-2540 We could remove these handlers - do we need to for a shared common store?
             * "Is it safe?" https://www.youtube.com/watch?v=mqrpPaNm8yw
             */
            mainSocket.subscribeForUpdates(selectionPointers, WS_HANDLER_COMPONENT_NAME);

            return { ...state, selectionPointers };
        }
        case COMMON_DATA_LIST_EVENTS_ERROR: {
            return { ...state, errorOccurred: action.errorOccurred };
        }
        case COMMON_DATA_LIST_EVENTS_STOP_LISTENING_FOR_WS_UPDATES: {
            const { selectionPointers = [] } = state;
            if (!selectionPointers.length) {
                return state;
            }
            const { events = [] } = action;
            const payload = events.length
                ? selectionPointers.filter(({ event_id: selectionPointerEventId }) => {
                        return events.find(event => {
                            const eventId = typeof event === 'object'
                                ? event.event_id
                                : event;

                            return eventId === selectionPointerEventId;
                        });
                    })
                : selectionPointers;

            if (payload.length) {
                mainSocket.unsubscribeForUpdates(payload, WS_HANDLER_COMPONENT_NAME);
            }

            return state;
        }
        default:
            return state;
    }
}

export default combineReducers({
    commonDataListEvents: commonDataListEventsReducer,
    commonData: commonStoreReducer,
    metaData: metaDataReducer,
});
